import { Component, NgZone, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Zone } from 'src/app/admin/models/zone.model';

import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { RodjendanskezoneService } from 'src/app/admin/services/rodjendanskezone.service';
import { validateZone } from 'src/app/utils/formValidators';

@Component({
  selector: 'app-add-birthday-zone-modal',
  templateUrl: './add-birthday-zone-modal.component.html',
  styleUrls: ['./add-birthday-zone-modal.component.scss'],
})
export class AddBirthdayZoneModalComponent implements OnInit {


  zone: Zone = new Zone()
  errMsg = '';
  playrooms$ = this.roomService.playrooms$;
  zoneNameQuery: string = '';

  maxAdultNumberQueryMin: string = '';
  maxChildNumbereQueryMin: string = ''
  maxAdultNumberQueryMax: string = ''
  maxChildNumbereQueryMax: string = ''

  roomnameQuery: string = ''
  currentPage: number = 1;
  itemsPerPage: number = 10
  messageError:string=''
  constructor(private modalController: ModalController, private roomService: PlayroomService, private rodjendanskezoneservice: RodjendanskezoneService) { }

  ngOnInit() {
    this.roomService.getAllPlayrooms();
    console.log("playrooms$")
    console.log(this.playrooms$)
  }

  addZone() {

    const formValidation = validateZone(this.zone);
    this.errMsg = formValidation.errMsg;
    console.log(this.zone, 'this.zone')

    console.log(formValidation, 'formValidation')

    if (formValidation.isValid) {

      this.rodjendanskezoneservice.addZone(this.zone).subscribe(res => {


        this.rodjendanskezoneservice.getAllZone({
          currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
          ZoneNameQuery: this.zoneNameQuery, MaxChildNumbereQueryMin: this.maxChildNumbereQueryMin, MaxChildNumbereQueryMax: this.maxChildNumbereQueryMax
          , MaxAdultNumberQueryMin: this.maxAdultNumberQueryMin, MaxAdultNumberQueryMax: this.maxAdultNumberQueryMax, RoomNameQuery: this.roomnameQuery
        })


        this.dismissModal();


      }, (err) => {
         

        if (err.error.errors.includes("birthdayzone can't be empty")) {
          this.messageError = 'Greška: Naziv zone mora biti upisan.';
        }

        else if (err.error.errors.includes("Room doesn't exists")) {
          this.messageError = 'Greška:Igraonica ne postoji .';
        }

        else if (err.error.errors.includes('birthadyzone-name-already-exists')) {
          this.messageError = 'Greška: Rodjendanska zona i igraonica sa istim imenima već postoje u sistemu .';
        }
        this.errMsg = this.messageError
      
        
        
        
        
        //JSON.stringify(err.error.title);
      });
    }

  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
